import React, { useState } from 'react';
import { TWButton } from '../../../../components/ui';
import ConnectFinance from '../../../connect/finance/connect-finance';
import ConnectSettlementBoundary from './connect-settlement-boundary';

// Collapsed on purpose. The Connect tab is an activation console whose
// tests pin "no money surface on this screen"; the settlement view is a
// money surface by definition, so it mounts only after an admin asks, and
// nothing in the collapsed state names fees, payouts, balances or margins.
// It renders regardless of routing model — a deactivated company still has
// history worth reading — but not for a company with no account, which has
// nothing to read.
const ConnectSettlement = ({ companyId, hasAccount }) => {
  const [open, setOpen] = useState(false);

  return (
    <section className="py-6">
      <h3 className="text-sm font-semibold text-slate-900 dark:text-slate-100">
        Settlement
      </h3>
      {!hasAccount ? (
        <p className="mt-3 text-sm text-slate-500 dark:text-slate-400">
          No Connect account yet.
        </p>
      ) : (
        <>
          <p className="mt-3 max-w-2xl text-sm text-slate-500 dark:text-slate-400">
            Charges, refunds, disputes and transfers on this company's Stripe
            account, with Stripe's buy rate beside Thisway's commercial rate.
          </p>
          <div className="mt-4">
            <TWButton
              size="sm"
              label={open ? 'Hide settlement' : 'Show settlement'}
              onClick={() => setOpen((prev) => !prev)}
            />
          </div>
          {open ? (
            <div className="mt-4">
              {/* A boundary inside ConnectFinance's own render could never
                  catch a throw from its own render — see
                  connect-settlement-boundary.js's own comment for why this
                  has to wrap it from out here instead. */}
              <ConnectSettlementBoundary>
                <ConnectFinance companyId={companyId} />
              </ConnectSettlementBoundary>
            </div>
          ) : null}
        </>
      )}
    </section>
  );
};

export default ConnectSettlement;
